import { commitmentsRecommendationsListSelector } from "./commitmentsRecommendationsListSelector";
import { RootState } from "../../../../store";

export const commitmentsRecommendationsExistsSelector = (state: RootState) => {
  const data = commitmentsRecommendationsListSelector(state);

  return !!data?.length;
};
